const InitNavigation = () => {
  const body = document.body;
  const siteNavigation = document.getElementById('site-navigation');
  const aosTrigger = document.querySelector('.aos-trigger');
  const masthead = document.getElementById('masthead');

  // Return early if the navigation doesn't exist.
  if (!siteNavigation) {
    return;
  }

  const button = siteNavigation.getElementsByTagName('button')[0];

  // Return early if the button doesn't exist.
  if ('undefined' === typeof button) {
    return;
  }

  const menu = siteNavigation.getElementsByTagName('ul')[0];

  // Hide menu toggle button if menu is empty and return early.
  if ('undefined' === typeof menu) {
    button.style.display = 'none';
    return;
  }

  if (!menu.classList.contains('nav-menu')) {
    menu.classList.add('nav-menu');
  }

  // Toggle the .toggled class and the aria-expanded value each time the button is clicked.
  button.addEventListener('click', function () {
    if (window.isMobile) {
      siteNavigation.classList.toggle('toggled');

      if (button.getAttribute('aria-expanded') === 'true') {
        button.setAttribute('aria-expanded', 'false');
        body.classList.remove('is-menu-open');
      } else {
        button.setAttribute('aria-expanded', 'true');
        body.classList.add('is-menu-open');
      }
    }
  });

  // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
  document.addEventListener('click', function (event) {
    const isClickInside = siteNavigation.contains(event.target);

    if (!isClickInside) {
      siteNavigation.classList.remove('toggled');
      button.setAttribute('aria-expanded', 'false');
      body.classList.remove('is-menu-open');
    }
  });

  // Get all the link elements within the menu.
  const links = menu.getElementsByTagName('a');

  // Get all the link elements with children within the menu.
  const linksWithChildren = menu.querySelectorAll(
    '.menu-item-has-children > a, .page_item_has_children > a'
  );

  // Toggle focus each time a menu link is focused or blurred.
  for (const link of links) {
    link.addEventListener('focus', toggleFocus, true);
    link.addEventListener('blur', toggleFocus, true);
  }

  const primaryMenu = document.querySelector('.primary-menu');
  primaryMenu.addEventListener('mouseleave', mouseEvent);
  primaryMenu.addEventListener('mouseenter', mouseEvent);

  function caculaterSubmenuHeight(t) {
    let maxHeight = 0;
    if (t === 0) {
      maxHeight = 0;
    } else {
      const submenus = document.querySelectorAll('.primary-menu .sub-menu');
      submenus.forEach((submenu) => {
        const height = submenu.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      maxHeight = aosTrigger.classList.contains('aos-animate') ? maxHeight + 60 : maxHeight + 100;
    }
    primaryMenu.style.setProperty('--h', `${maxHeight}px`);
    // masthead.style.setProperty('--h', `${maxHeight}px`);
  }
  function mouseEvent(e) {
    if (e.type === 'mouseenter') {
      body.classList.add('is-menu-hover');
      caculaterSubmenuHeight();
    } else {
      body.classList.remove('is-menu-hover');
      caculaterSubmenuHeight(0);
    }
  }

  // Toggle focus each time a menu link with children receive a touch event.
  for (const link of linksWithChildren) {
    link.addEventListener('touchstart', toggleFocus, { passive: true });
  }

  /**
   * Sets or removes .focus class on an element.
   */
  function toggleFocus(event) {
    if (body.classList.contains('is-mobile')) {
      if (event.type === 'focus' || event.type === 'blur') {
        let self = this;
        // Move up through the ancestors of the current link until we hit .nav-menu.
        while (!self.classList.contains('nav-menu')) {
          // On li elements toggle the class .focus.
          if ('li' === self.tagName.toLowerCase()) {
            self.classList.toggle('focus');
          }
          self = self.parentNode;
        }
      }

      if (event.type === 'touchstart') {
        const menuItem = this.parentNode;
        // event.preventDefault();
        for (const link of menuItem.parentNode.children) {
          if (menuItem !== link) {
            link.classList.remove('focus');
          }
        }
        menuItem.classList.toggle('focus');
      }
    }
  }

  const mainMenu = document.querySelectorAll('.main-menu-item');
  Array.from(mainMenu).forEach((el) => {
    if (el.classList.contains('has-sub')) {
      const mainMenuLink = el.querySelector('.main-menu-link');
      const subMenuFirst = el.querySelector('.sub-menu .sub-menu-link');
      mainMenuLink.href = subMenuFirst.href;
    }
  });

  const btnArrows = document.querySelectorAll('.btn-arrow');
  Array.from(btnArrows).forEach((el) => {
    el.addEventListener('click', function (e) {
      e.preventDefault();

      const menuWrap = this.closest('.nav-menu');
      const menuItems = menuWrap.querySelectorAll('.menu-item-has-children');
      const clickedItem = this.closest('.menu-item-has-children');

      menuItems.forEach((item) => {
        if (item === clickedItem) {
          item.classList.toggle('is-open');
        } else {
          item.classList.remove('is-open');
        }
      });

      // console.log(menuWrap);

      // const parent = this.parentNode;
      // const subMenu = parent.querySelector('.sub-menu');

      // const isOpen = subMenu.classList.contains('is-open');

      // // 모든 열린 항목 닫기
      // document.querySelectorAll('.sub-menu.is-open').forEach((menu) => {
      //   menu.classList.remove('is-open');
      // });
      // document.querySelectorAll('.btn-arrow.is-open').forEach((btn) => {
      //   btn.classList.remove('is-open');
      // });

      // // 자신이 닫혀있던 상태였다면 열기
      // if (!isOpen) {
      //   subMenu.classList.add('is-open');
      //   this.classList.add('is-open');
      // }
    });
  });
};
export default InitNavigation;
